import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import FareFamilyFlightTileV2TimeLine from '../V2/FareFamily/FareFamilyFlightTileV2TimeLine'
import Image from 'components/Common/Image'
import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'LuxKit/Typography/BodyText'
import moment from 'moment'
import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'
import { SHORT_DAY_NAME_DAY_MONTH } from 'constants/dateFormats'

const AirlineLogoContainer = styled(Group)`
  flex-shrink: 0;
  width: ${rem(40)};
  height: ${rem(40)};

  ${mediaQueryUp.tablet} {
    &:not(.desktopShowLogo) {
      display: none;
    }
  }
`

const AirlineLogoImage = styled(Image)`
  max-width: 100%;
  max-height: 100%;
`

const SegmentDayLabel = styled(BodyText)`
  ${mediaQueryUp.tablet} {
    &.desktopShowLogo {
      margin-left: ${rem(56)};
    }
  }
`

interface Props {
  className?: string
  journey: App.JourneyV2
  desktopShowLogo: boolean
  showExactDate: boolean
  segment: 'departing' | 'returning'
  route: App.CharterBundleRoute
}

function CharterTileIndividualFlight({ className, journey, desktopShowLogo, showExactDate, segment, route }: Props) {
  const flights = journey.flightGroup.flights
  const duration = journey.flightGroup.totalFlightDuration
  const dayName = moment(flights[0].departingDate).format(showExactDate ? SHORT_DAY_NAME_DAY_MONTH : 'dddd')

  const routeInfo = CHARTER_FLIGHT_DETAILS[route]

  return <Group direction="vertical" gap={8} className={className}>
    <SegmentDayLabel variant="small" className={clsx({ desktopShowLogo })}>
      {segment === 'departing' && dayName}
      {segment === 'returning' && dayName}
    </SegmentDayLabel>
    <Group direction="horizontal" gap={16}>
      <AirlineLogoContainer direction="horizontal" verticalAlign="center" horizontalAlign="center" className={clsx({ desktopShowLogo })}>
        <AirlineLogoImage
          width={40}
          image={routeInfo.operatorLogo}
          format="svg"
          enhancedFormats={false}
        />
      </AirlineLogoContainer>
      <FareFamilyFlightTileV2TimeLine
        departureAirport={flights[0].departureAirport}
        departureTime={flights[0].departingTime}
        departureDate={flights[0].departingDate}
        arrivalAiport={flights.at(-1)!.arrivalAirport}
        arrivalTime={flights.at(-1)!.arrivalTime}
        arrivalDate={flights.at(-1)!.arrivalDate}
        stops={journey.flightGroup.numberOfStops}
        duration={`${duration.hours}h ${duration.minutes}m`}
        showDate={false}
      />
    </Group>
  </Group>
}

export default CharterTileIndividualFlight
